<div mat-dialog-title>
  <div class="titulo-onboarding">

    @if(step == 1){
      Agenda tu reunión de forma inmediata
    }

    @if(step == 2){
      <span class="material-symbols-outlined" style="font-size: 50px;color:var(--simpli-secondary); transform: rotate(180deg);">error</span>
      <br>
      }


      <div mat-dialog-close class="close-dialog-icon"><span class="material-symbols-outlined">close</span></div>
    </div>
    <div class="subtitulo-onboarding">
      @if(step == 1){
        Asigna la fecha y hora para tu videollamada con un ejecutivo.

      }


    </div>
  </div>

  <div mat-dialog-content>

    @if(step == 1){

      @if(loading_feriados){
        <loading-interno></loading-interno>
        }@else if (error_loading_data) {
        <div class="error_loading">
          <img src="../../../assets/iconografia/Iconografia - calendar.png">
          <div class="no-hours-message">No hay horas disponibles en este momento</div>
        </div>

      }
      @else{
      <mat-card class="calendar">
        <mat-calendar [dateFilter]="dateFilter" [(selected)]="selected" (selectedChange)="sel_fecha($event)"></mat-calendar>
      </mat-card>
    }


    @if(selecciono_fecha){
      <div class="container-hour">
        @if(filteredBloques.length === 0){
          <div class="no-hours-message">No hay horas disponibles para esta fecha.</div>
          }@else{
          @for (i of filteredBloques; track i; let idx = $index) {
<div class="hour-sel" [ngClass]="{ 
          'selected': selectedIndex === idx,
          'disabled': isTimeSlotDisabled(i.hora)
        }" (click)="!isTimeSlotDisabled(i.hora) && selectHour(idx, i.hora)"
            >{{i.hora}}</div>
          }
        }
      </div>
    }

    @if(hora_seleccionada != null){
      <div style="margin-top: 30px;text-align: center;">
        <div style="font-size: 15px;">Programaste una reunión para el <strong>{{fecha_mandar}}</strong> a las
        <strong>{{hora_seleccionada}}</strong> horas.</div>
      </div>
    }

  }



  @if(step == 2){
    <div class="titulo-onboarding">
      ¡todo listo! Nuestra reunión ya está agendada
    </div>
    <div class="subtitulo-onboarding">
      Enviamos el resumen del día y hora marcada a tu correo.
    </div>


  }



</div>

<div mat-dialog-actions style="justify-content: center !important;">
  <div class="caja-botones" style="text-align: center !important;">
    @if(step == 1){
      @if (!error_loading_data) {
        <button mat-stroked-button [disabled]="loading || hora_seleccionada == null" class="primary-button"
          (click)="agendar()">
          @if (loading == false) {
            <span style="text-decoration: none;color: inherit">Agendar reunión</span>
          }
          @if (loading == true) {
            <span style="color:var(--simpli-secondary)"><span class="material-symbols-outlined mat-spin">progress_activity</span></span>
          }
        </button>
      }
      @if (error_loading_data) {
        <button mat-stroked-button class="primary-button" mat-dialog-close>Cerrar</button>
      }

      }@else{
      <button mat-stroked-button class="primary-button" (click)="continuar()">Continuar</button>
    }

  </div>
</div>